export const classes = {
  wrapper:
    'size-full max-w-[1250px] min-w-[400px] flex flex-col ml-6 pr-8 py-8',
  grid: 'pb-12',
};
